import React from 'react';
import {
  FDStack,
} from '@facet-wealth/design';
import { Avatar, AvatarGroup } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4';
import fr from 'facet-rest';

function RecommendedPlannerAvatarGroup(
  {
    recommendedPlannerProfileImageRel,
    restOfTeamAvatars,
  },
) {
  return (
    <FDStack direction={'column'} alignItems={'center'}>
      <AvatarGroup
        max={restOfTeamAvatars.length}
        spacing={'medium'}
      >
        {restOfTeamAvatars.map((avatar) => {
          const profileImageRel = avatar.withRelationship(fr.relationships.avatar.name, (rel) => rel, () => null);
          return (<Avatar
            alt={profileImageRel?.meta('altText')}
            src={profileImageRel?.link('related').url()}
            style={{
              width: 48,
              height: 48,
            }}
          />);
        })}
      </AvatarGroup>
      <Avatar
        alt={recommendedPlannerProfileImageRel?.meta('altText')}
        src={recommendedPlannerProfileImageRel?.link('related').url()}
        style={{
          width: 112,
          height: 112,
          border: '4px solid white',
          marginTop: '-15px', // Adjust this value to control the overlap
          zIndex: 10, // Ensure the large avatar is on top of the small stack
        }}
      />
    </FDStack>
  );
}

export default RecommendedPlannerAvatarGroup;
